/**
 * @file
 * Pluxee pager script.
 */

(function ($) {

    'use strict';

    Drupal.behaviors.pluxeeAutoScroll = {
        attach: function (context, settings) {
            $(document).ready(function() {
              // Product blog scroll.
              const productDescription = $("#product-description");
              const productTag = $("div[name='product']");
              if( $('.bef-link--selected').length){
                    if (productDescription.length) {
                      $("html, body").animate({ scrollTop: productDescription.offset().top - 90 }, "slow");
                    } else if (productTag.length) {
                      $("html, body").animate({ scrollTop: productTag.offset().top - 90 }, "slow");
                    }
                }
              // Search result scroll.
              const faqSearchResult = $(".total-faq-result");
              if (faqSearchResult.length) {
                const headerHeight = $("#block-headerlogo").outerHeight(true);
                const formInput = $("#pluxee-faq-search-form");
                $("html, body").animate({ scrollTop: formInput.offset().top - (headerHeight + 16) }, "slow");
              }
            });
        }
    };
})(jQuery);
